import { memo } from "react";

interface CutleryImageProps {
  className?: string;
}

export const CutleryImage = memo(function CutleryImage({ className }: CutleryImageProps) {
  return <img src="/assets/images/cutlery.png" alt="Cutlery" className={className} />;
});
